import * as React from 'react'

import { styled, spacing, mq } from '@thg-commerce/gravity-theme'
import {
  BreakpointKey,
  breakpointUtils,
} from '@thg-commerce/gravity-theme/breakpoints'
import { Skeleton } from '@thg-commerce/gravity-elements'

import { Directions } from './types'

interface ContainerProps {
  directions: Directions
  condensed: boolean
}

interface ImageProps {
  maxWidths?: string[]
}

interface ProductBlockSkeletonProps {
  condensed?: boolean
  directions?: Directions
}

export const StyledImage = styled(Skeleton)<ImageProps>`
  width: 100%;
  height: auto;
  padding-top: 100%;
`

export const SkeletonText = styled(Skeleton)`
  width: 60%;
  max-height: ${spacing(2.4)};
`

export const AttributesContainer = styled.div<{
  justifyContent?: string
  alignItems?: string
  condensed?: boolean
}>`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: ${({ justifyContent }) => justifyContent || 'center'};
  align-items: ${({ alignItems }) => alignItems || 'flex-start'};
  row-gap: ${({ condensed }) => (condensed ? spacing(1) : spacing(2))};
`

export const Container = styled.div<ContainerProps>`
  display: flex;
  width: 100%;
  max-height: 100%;
  text-decoration: none;
  row-gap: ${spacing(2)};
  ${(props) =>
    props.directions.map(
      (direction, index) => `
        ${mq(
          props.theme.breakpointUtils.map,
          breakpointUtils.keys[index] as BreakpointKey,
        )} {
          flex-direction: ${direction};
        }
      `,
    )}
`

export const ProductBlockSkeleton = ({
  condensed = false,
  directions = ['column'],
}: ProductBlockSkeletonProps) => {
  return (
    <Container {...{ condensed, directions }}>
      <StyledImage />
      <AttributesContainer>
        <SkeletonText />
        <SkeletonText />
        <SkeletonText />
      </AttributesContainer>
    </Container>
  )
}
